
import { DateOnly, RodneCislo } from '@tpa/api';
import { boolean, z } from 'zod';
import { zAdresa, zDite } from './employee-2026.types';


// TPA origin
export const VariantaNull: EmpTabsFormModelV2024 = {
  dodatecneAtributy: {},
  personalPart: {
    health: {},
    personalInfo: {},
    execution: {
      exekuce: null,
    },
  },
  taxDeclaration: {
    rezidentura: {},
    taxDeclaration: {
      monthDiscount: {},
      partner: {},
      children: {
        deti: [],
      },
    },
  },
};

// Multistep guide default
export const EMP_TABS_INIT_DATA: EmpTabsFormModelV2024 = {
  pre: true,
  ...VariantaNull,
};


export const zDodatecenAtributy = z.object({
  nazev: z.string().optional().nullable(),
  value: z.string().optional().nullable(),
  type: z.string().optional().nullable(),
  placeholder: z.string().optional().nullable(),
});


export const zDuchody = z.object({
  pobiramDuchod: z.boolean().optional().nullable(),
  predcasny: z.boolean().optional().nullable(),
  starobni: z.boolean().optional().nullable(),
  invalidni: z.boolean().optional().nullable(),
  jiny: z.string().optional().nullable(),
  jinyDuchod: z.boolean().optional().nullable(),
});

export const zZdravotniPojistovnaAStav = z.object({
  zdravPojistovna: z.number().nullish(),
  jinaZdravPojistovna: z.string().nullish(),
  cisloPojistence: z.string().nullish(),
  zpsZtpp: z.number().nullish(),
  duchody: zDuchody.optional(),
  ztpp: z.boolean().nullish(),
  a1: z.boolean().nullish(),
  zdravotniZnevyhodneni: z.string().nullish(),
});

export const zDoklad = z.object({
  cisloPasu: z.any().optional().nullable(),
  //expiracePasu: z.date().optional().nullable(),
  expiracePasu: DateOnly.nullish(),
  identifikace: z.number().optional().nullable(),
});

export const zUplatneni = z.object({
  narokVeVysi: z.string().optional().nullable(),
  ztpp: z.boolean().optional().nullable(),
  zletileDite: z.boolean().optional().nullable(),
  mesice: z.number().optional().nullable(),
});



export const zEmpTabsFormModelV2024 = z.object({
  pre: z.boolean().optional(),
  personalPart: z
    .object({
      personalInfo: z
        .object({
          jmeno: z.string().optional().nullable(),
          prijmeni: z.string().optional().nullable(),
          email: z.string().optional().nullable(),
          permanentniAdresa: zAdresa.nullish(),
          kontaktniAdresa: zAdresa.nullish(),
          prechodnaAdresa: zAdresa.nullish(),
          titulpred: z.string().optional().nullable(),
          titulza: z.string().optional().nullable(),
          rodnePrijmeni: z.string().optional().nullable(),
          rodneCisloADatumNarozeni: RodneCislo.nullish(),
          statNarozeni: z.string().optional().nullable(),
          mistoNarozeni: z.string().optional().nullable(),
          rodinnyStav: z.string().nullish(),
          vzdelani: z.string().nullish(),
          pocetVychDeti: z.number().optional().nullable(),
          statniPrislusnost: z.string().optional().nullable(),
          druhaStatniPrislusnostCheck: z.boolean().optional().nullable(),
          druhaStatniPrislusnost: z.any().optional().nullable(),
          pohlavi: z.string().nullish(),
        })
        .optional()
        .nullable(),

      // allowContactAddress?: boolean | null;
      // allowTemporaryAddress?: boolean | null;
      permanentniAdresa: zAdresa.nullish(),
      kontaktniAdresa: zAdresa.nullish(),
      prechodnaAdresa: zAdresa.nullish(),
      mamCeskouPrechodnouAdresu: boolean().optional().nullish(),

      allowContactAddress: z.boolean().optional(),
      allowTemporaryAddress: z.boolean().optional(),

      wage: z
        .object({
          salaryForm: z.string().nullish(),
          cisloUctu: z.string().nullish(),
          idUstavu: z.string().nullish(),
          iban: z.string().nullish(),
        })
        .nullable()
        .optional(),

      health: zZdravotniPojistovnaAStav.optional().nullable(),

      idcard: z
        .object({
          typDokladu: z.string().nullish(),
          vydalStat: z.string().nullish(),
          doklad: zDoklad.nullish(),
          cisloDokladu: z.string().nullish(),
          datumExpirace: DateOnly.nullish(),
        })
        .optional(),

      execution: z
        .object({
          exekuce: z.boolean().nullish(),
        })
        .optional()
        .nullable(),
      dalsiPracovniPomer: z
        .object({
          dalsiPracovniPomer: z.boolean().nullish(),
          nazevDalsihoZamestnavatele: z.string().nullish(),
          sidloDalsihoZamestnavatele: z.string().nullish(),
        })
        .nullable()
        .optional(),
    })
    .optional(),
  //taxDeclaration optional
  taxDeclaration: z
    .object({
      rezidentura: z
        .object({
          rezidentura: z.string().or(z.boolean()).nullish(),
          rezidenturaVeState: z.string().nullish(),
          rezidenturaText: z.string().nullish(),
          rezidenturaVyhodnoceni: z.string().nullish(),
          identifikace: z.string().nullish(),
          zdrzovaniVCR: z.boolean().nullish(),
          studiumVCR: z.boolean().nullish(),
        })
        .nullable()
        .optional(),
      taxDeclaration: z
        .object({
          monthDiscount: z
            .object({
              //vsechno objekty optional
              zakladniSlevaNaPoplatnika: z
                .object({ value: z.boolean().nullish() })
                .nullable()
                .optional(),
              rozsirenaSlevaNaInvalidituMesice: z
                .object({ value: z.number().nullish() })
                .nullable()
                .optional(),
              zakladniSlevaNaInvalidituMesice: z
                .object({ value: z.number().nullish() })
                .nullable()
                .optional(),
              slevaNaDrziteleZTPPMesice: z
                .object({ value: z.number().nullish() })
                .nullable()
                .optional(),
              slevaNaStudentaMesice: z
                .object({ value: z.number().nullish() })
                .nullable()
                .optional(),
            })
            .nullable()
            .optional(),
          children: z
            .object({
              deti: z.array(zDite).optional(),
              // ????? vubec nevim k cemu to je
              // jineProhlaseni?: boolean;
            })
            .nullable()
            .optional(),
          partner: z
            .object({
              dalsiPoplatnik: z.boolean().nullish(),
              jmenoPoplatnika: z.string().nullish(),
              prijmeniPoplatnika: z.string().nullish(),
              rodneCisloADatumNarozeniPoplatnika: RodneCislo.nullish(),
              trvalyPobytPoplatnika: zAdresa.nullish(),

              uplatnujePoplatnik: z.boolean().nullish(),
              zamestnaniPoplatnika: z.boolean().nullish(),

              platceDanePoplatnika: z.string().nullish(),
              adresaPlatceDanePoplatnika: zAdresa.nullish(),
            })
            .nullable()
            .optional(),
          soucasneNeuplatnuji: z.boolean().nullish(),

          //affidavit optional a nullable
          affidavit: z
            .nullable(
              z
                .object({
                  chciProhlaseni: z.boolean().nullish(),
                  prohlaseniKProhlaseni: z.boolean().nullish(),
                })
                .optional()
                .nullable()
            )
            .optional(),
        })
        .nullable()
        .optional(),

      datumNastupu: DateOnly.nullish(),
      datumUkonceni: DateOnly.nullish(),
    })
    .nullable()
    .optional(),
  pravdivostUdaju: z.boolean().nullish(),
  dodatecneAtributy: z.any().nullish(),
});



// interface ServerHeoModel {
//   jmeno?: string;
//   prijmeni?: string;
//   email?: string;
//   permanentniAdresa?: Adresa;
//   kontaktniAdresa?: Adresa;
//   prechodnaAdresa?: Adresa;
//   titulpred?: string;
//   titulza?: string;
//   rodnePrijmeni?: string;
//   rodneCislo?: string;
//   datumNarozeni?: string;
//   mistoNarozeni?: string;
//   rodinnyStav?: string;

//   vzdelani?: string;
//   pocetVychDeti?: number;
//   statniPrislusnost?: string;
//   cisloUctu?: string;
//   idUstavu?: string;
//   iban?: string;
//   cisloDokladu?: string;
//   datumExpirace?: string;
//   chciProhlaseni?: boolean;
//   datumNastupu?: string;
// }

export const zServerHeoModel = z.object({
  jmeno: z.string().nullish(),
  prijmeni: z.string().nullish(),
  email: z.string().nullish(),
  permanentniAdresa: zAdresa.nullish(),
  kontaktniAdresa: zAdresa.nullish(),
  prechodnaAdresa: zAdresa.nullish(),
  mamCeskouPrechodnouAdresu: boolean().nullish(),
  titulpred: z.string().nullish(),
  titulza: z.string().nullish(),
  rodnePrijmeni: z.string().nullish(),
  rodneCisloADatumNarozeni: RodneCislo.nullish(),
  mistoNarozeni: z.string().nullish(),
  statNarozeni: z.string().nullish(),
  rodinnyStav: z.string().nullish(),

  vzdelani: z.string().nullish(),
  pocetVychDeti: z.number().nullish(),
  statniPrislusnost: z.string().nullish(),
  cisloUctu: z.string().nullish(),
  idUstavu: z.string().nullish(),
  iban: z.string().nullish(),
  cisloDokladu: z.string().nullish(),
  datumExpirace: DateOnly.nullish(),
  chciProhlaseni: z.boolean().nullish(),
  datumNastupu: z.string().nullish(),
  datumUkonceni: z.string().nullish(),
  pohlavi: z.string().nullish(),


});

// interface ServerAppModel {
//   druhaStatniPrislusnost?: any;
//   rezidentura?: string;
//   rezidenturaVeState?: string;
//   rezidenturaText?: string;
//   rezidenturaVyhodnoceni?: string;
//   zdravotniPojistovnaAStav?: ZdravotniPojistovnaAStav;
//   doklad?: Doklad;
//   dalsiPracovniPomer?: boolean | null;
//   exekuce?: boolean | null;
//   jineProhlaseni?: boolean;
//   deti?: Dite[];
//   druhaStatniPrislusnostCheck?: boolean;
//   pohlavi?: string;
//   zdrzovaniVCR?: boolean | null;
//   studiumVCR?: boolean | null;
//   salaryForm?: string;
//   prohlaseniKProhlaseni?: boolean;
//   nazevDalsihoZamestnavatele?: string | null;
//   sidloDalsihoZamestnavatele?: string | null;
//   dalsiPoplatnik?: boolean;

//   jmenoPoplatnika?: string;
//   prijmeniPoplatnika?: string;
//   rodneCisloPoplatnika?: string;
//   trvalyPobytPoplatnika?: string;
//   uplatnujePoplatnik?: boolean;
//   zamestnaniPoplatnika?: boolean;
//   platceDanePoplatnika?: string;
//   adresaPlatceDanePoplatnika?: string;
//   soucasneNeuplatnuji?: boolean;
//   pravdivostUdaju?: boolean;
//   typDokladu?: string;
//   vydalStat?: string;
//   identifikace?: string | null;
//   /// mesicni slevy
//   zakladniSlevaNaPoplatnika?: boolean;
//   rozsirenaSlevaNaInvalidituMesice?: MonthFlags;
//   zakladniSlevaNaInvalidituMesice?: MonthFlags;
//   slevaNaDrziteleZTPPMesice?: MonthFlags;
//   slevaNaStudentaMesice?: MonthFlags;
// }

export const zServerAppModel = z.object({
  druhaStatniPrislusnost: z.string().nullish(),
  rezidentura: z.string().or(z.boolean()).nullish(),
  rezidenturaVeState: z.string().nullish(),
  rezidenturaText: z.string().nullish(),
  rezidenturaVyhodnoceni: z.string().nullish(),
  zdravotniPojistovnaAStav: zZdravotniPojistovnaAStav.nullish(),
  doklad: zDoklad.nullish(),
  dalsiPracovniPomer: z.boolean().nullish(),
  exekuce: z.boolean().nullish(),
  jineProhlaseni: z.boolean().nullish(),
  deti: zDite.array().nullish(),
  druhaStatniPrislusnostCheck: z.boolean().nullish(),
  // pohlavi: z.string().nullish,
  zdrzovaniVCR: z.boolean().nullish(),
  studiumVCR: z.boolean().nullish(),
  salaryForm: z.string().nullish(),
  prohlaseniKProhlaseni: z.boolean().nullish(),
  nazevDalsihoZamestnavatele: z.string().nullish(),
  sidloDalsihoZamestnavatele: z.string().nullish(),
  dalsiPoplatnik: z.boolean().nullish(),

  jmenoPoplatnika: z.string().nullish(),
  prijmeniPoplatnika: z.string().nullish(),
  rodneCisloADatumNarozeniPoplatnika: RodneCislo.nullish(),
  trvalyPobytPoplatnika: zAdresa.nullish(),
  uplatnujePoplatnik: z.boolean().nullish(),
  zamestnaniPoplatnika: z.boolean().nullish(),
  platceDanePoplatnika: z.string().nullish(),
  adresaPlatceDanePoplatnika: zAdresa.nullish(),
  soucasneNeuplatnuji: z.boolean().nullish(),
  pravdivostUdaju: z.boolean().nullish(),
  typDokladu: z.string().nullish(),
  vydalStat: z.string().nullish(),
  identifikace: z.string().nullish(),
  zakladniSlevaNaPoplatnika: z.boolean().nullish(),
  rozsirenaSlevaNaInvalidituMesice: z.number().nullish(),
  zakladniSlevaNaInvalidituMesice: z.number().nullish(),
  slevaNaDrziteleZTPPMesice: z.number().nullish(),
  slevaNaStudentaMesice: z.number().nullish(),
});
export type EmpTabsFormModelV2024 = z.infer<typeof zEmpTabsFormModelV2024>;


export type ZdravotniPojistovnaAStav = z.infer<
  typeof zZdravotniPojistovnaAStav
>;
export type Doklad = z.infer<typeof zDoklad>;
export type Uplatneni = z.infer<typeof zUplatneni>;
export type ServerHeoModel = z.infer<typeof zServerHeoModel>;
export type ServerAppModel = z.infer<typeof zServerAppModel>;

export const MY_TEST_CARD = {
  attachments: null,
  karta: {
    jmeno: 'a',
    prijmeni: 'a',
    email: 'ala',
    permanentniAdresa: {
      ulice: 'sssasdf',
      popCislo: '767',
      orCislo: '14',
      mesto: 'Praha 4',
      psc: '140 00',
      zeme: 'CZ',
    },
    kontaktniAdresa: {
      ulice: 'sssasdf',
      popCislo: '767',
      orCislo: '14',
      mesto: 'Praha 4',
      psc: '140 00',
      zeme: 'CZ',
    },
    prechodnaAdresa: {
      ulice: null,
      popCislo: null,
      orCislo: null,
      mesto: null,
      psc: null,
      zeme: null,
    },
    titulpred: 'MgA.',
    titulza: null,
    rodnePrijmeni: 's',
    rodneCisloADatumNarozeni: {
      ceskeRodneCislo: true,
      rodneCislo: '745222/0215'
    },
    datumNarozeni: '1974-02-22T00:00:00Z',
    mistoNarozeni: 'Praha',
    rodinnyStav: 'married',
    pohlavi: 'man',
    vzdelani: 'T',
    // pocetVychDeti: 0,
    statniPrislusnost: 'CZ',
    cisloUctu: '1110169143',
    idUstavu: '0800',
    iban: null,
    cisloDokladu: null,
    datumExpirace: null,
    chciProhlaseni: true,
    datumNastupu: null,
  },
  dodatecneAtributy: {},
  app: {
    rezidentura: 'true',
    rezidenturaVeState: 'CZ',
    rezidenturaText: null,
    rezidenturaVyhodnoceni: 'true',
    zdrzovaniVCR: true,
    studiumVCR: null,
    identifikace: null,
    doklad: null,
    typDokladu: null,
    vydalStat: null,
    dalsiPracovniPomer: null,
    exekuce: false,
    salaryForm: 'cash',
    pohlavi: 'man',
    prohlaseniKProhlaseni: true,
    soucasneNeuplatnuji: false,
    zdravotniPojistovnaAStav: {
      zdravPojistovna: 111,
      cisloPojistence: '9206260184',
      ztpp: false,
      zdravotniZnevyhodneni: 'no',
    },
    zakladniSlevaNaPoplatnika: true,
    rozsirenaSlevaNaInvalidituMesice: null,
    zakladniSlevaNaInvalidituMesice: 4095,
    slevaNaDrziteleZTPPMesice: null,
    slevaNaStudentaMesice: 4095,
  },
};
